import { IUser } from '@common/types';
import { paths } from '@common/types/api.types';
import { postRequest } from '@config/axios/axios.config';
import { jwtDecode } from 'jwt-decode';
import { setTokens } from '@store';

export const refreshTokens = async (refreshToken: string) => {
  const response = await postRequest<
    paths['/auth/refresh-tokens']['post']['requestBody']['content']['application/json'],
    paths['/auth/refresh-tokens']['post']['responses']['200']['content']['application/json']
  >('/auth/refresh-tokens', { token: refreshToken });

  const data = response.data;

  setTokens({
    token: data.token,
    refreshToken: data.refresh_token,
  });

  return data;
};

export const setUserData = (token: string, setUser: (data: IUser) => void) => {
  if (token) {
    const decodedUser = jwtDecode(token) as IUser;
    setUser(decodedUser);
  }
};

export const checkUserPermission = (data: IUser | null, permission: string) => {
  return data?.permissions?.includes(permission) ?? false;
};
